export const environment = {
    production: true,
    api: 'https://staging.api.classichub.co.nz',
    buildVersion: '2026.2.10.8',
    uri: 'https://staging.classichub.co.nz',
    envName: 'staging',
    isTest: true,

};

